import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { BaseUrl } from '../../helper/BaseUrl';
export default function ProjectCard({ initialData }) {
    const [allData, setAllData] = useState(initialData || []);
    const [visibleCount, setVisibleCount] = useState(6);
    const [isLoadMore, setIsLoadMore] = useState(true);
    const [hasFetched, setHasFetched] = useState(false);
    const fetcher = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/projects`, {
                method: 'GET',
            });

            const result = await response.json();

            if (result.projects === false) {
                throw new Error(`API error: ${result.message}`);
            }
            setAllData(result.projects || []);
        } catch (error) {
            console.error('Fetch error:', error.message);
            setAllData([]);
        } finally {
            setHasFetched(true);
        }
    };

    useEffect(() => {
        fetcher();
    }, [])


    const handleLoadMore = () => {
        if (isLoadMore) {
            setVisibleCount(prev => Math.min(prev + 3, allData.length));

            if (visibleCount + 3 >= allData.length) {
                setIsLoadMore(false);
            }
        } else {
            setVisibleCount(6);
            setIsLoadMore(true);
        }
    };





    return (
        <>
            <section className="project-card-listing">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-lg-10">
                            <span className="gradient-color">Project Gallery</span>
                            <div className="project-text">
                                <h2 className="heading">Purpose-Built Laundry Projects Designed for Demanding Environments</h2>
                                <p>Each project delivers tailored laundry solutions engineered for efficiency, compliance, durability, & consistent performance across high-demand commercial and institutional environments.</p>
                            </div>
                        </div>
                    </div>
                    <div className="project-row">
                        <div className="row">
                            {allData.slice(0, visibleCount).map((data, index) => (
                                <div className="col-lg-6 col-sm-6" key={index}>
                                    <div className="project-card">
                                        <Link to={`/project/${data.slug}`} className="project-card-inner" >
                                            <div className="image-wrapper">
                                                <img src={data?.thumbnail ? `${BaseUrl}${data.thumbnail}` : undefined} className="img-responsive" alt={data?.alt_thumbnail} loading="lazy" />
                                            </div>
                                            <div className="project-detail">
                                                <span className="gradient-color">{data?.country} </span>
                                                <h3 className="heading">{data?.title}</h3>
                                                <div className="arrow-butn">View Projects<img src="/assets/images/arrow.webp" loading="lazy" alt="arrow" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                            {allData.length > 6 && (
                                <div className="col-sm-12 col-lg-12">
                                    <div className='text-center'>
                                        <Link onClick={handleLoadMore} className="default-btn"><span>{isLoadMore ? "View More" : "View Less"}</span></Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {hasFetched && allData.length === 0 && (
                        <div className="error-top-messege">
                            <h3 className="heading">No Data Found</h3>
                            <p>There are no project listings available right now. We are continuously updating our portfolio to showcase our latest work.</p>
                        </div>
                    )}

                </div>
            </section>
        </>
    )
}
